/*
 * View for the context menu
 */

define([
  "marionette",
  "modules/header/contextMenu/template/contextMenuTemplate.html",
  "modules/header/contextMenu/template/contextMenuItemTemplate.html",
], function (Marionette, ContextMenuTemplate, ContextMenuItemTemplate) {
  var ContextMenuView = {};

  ContextMenuView.contextMenuItemView = Marionette.ItemView.extend({
    template: ContextMenuItemTemplate,
    tagName: "li",
    className: "context-menu",
    hideItem: function () {
      this.model.set("hidden", true);
      this.$el.hide();
    },
    modelEvents: {
      "change:hidden": "toggleShow",
    },
    onRender: function () {
      this.$el.i18n();
      //if the menu item is inactive, hide it
      if (this.model.get("hidden")) {
        this.hideItem();
      }
    },
    showItem: function () {
      this.model.set("hidden", false);
      this.$el.show();
    },
    toggleShow: function () {
      if (this.model.get("hidden")) {
        this.hideItem();
      } else {
        this.showItem();
      }
    },
    triggers: {
      "click a": "click:menu",
    },
  });

  ContextMenuView.contextMenuView = Marionette.CompositeView.extend({
    template: ContextMenuTemplate,
    itemViewContainer: "ul",
    itemView: ContextMenuView.contextMenuItemView,
  });

  return ContextMenuView;
});
